import { FC, Fragment, ReactNode } from 'react';
import {
  FAIcon,
  GenericLink,
  Accordion,
  ControlIconType,
  FontSize,
  useBreakpoint,
  Breakpoints,
} from '@nextgen-web-framework/all';
import HelpDeskImg from './HelpDeskImg';
import type { FooterNavigationProps } from './types/propsTypes';
import styles from './FooterNavigation.module.scss';

const FooterNavigation: FC<FooterNavigationProps> = ({ footerData, helpingData }) => {
  const viewPortType = useBreakpoint();
  const isMobile = [Breakpoints.SM, Breakpoints.XS].includes(viewPortType as Breakpoints);
  const renderFooter = () => {
    let componentToRender: ReactNode;
    if (isMobile) {
      componentToRender = (
        <>
          {footerData?.map((element) => (
            <>
              <Accordion
                key={`${element.heading}`}
                id={`footer-accordion${element.subheading}`}
                title={element.heading}
                iconType={ControlIconType.ARITH}
                isBorderDesign={false}
                fontSize={FontSize.SMALL}
              >
                <>
                  {element.subheading?.map((item) => (
                    <GenericLink
                      key={item.text}
                      href={item.url}
                      target={item.target}
                      className={styles['footer-nav-link']}
                    >
                      <div className={styles['footer-nav-heading-item']}>{item.text}</div>
                    </GenericLink>
                  ))}
                </>
              </Accordion>
              <div className={styles['division']}></div>
            </>
          ))}
        </>
      );
    } else {
      componentToRender = (
        <>
          {footerData?.map((element) => (
            <Fragment key={element?.heading}>
              <div
                key={`${element.heading}${element.subheading}`}
                className={styles['footer-container']}
                data-testid="footer-container-test-id"
              >
                <h6 className={styles['footer-nav-heading']}>{element.heading}</h6>
                {element.subheading?.map((item) => (
                  <GenericLink
                    key={item.text}
                    href={item.url}
                    target={item.target}
                    className={styles['footer-nav-link']}
                  >
                    <div className={styles['footer-nav-heading-item']}>{item.text}</div>
                  </GenericLink>
                ))}
              </div>
            </Fragment>
          ))}
        </>
      );
    }
    return componentToRender;
  };
  return (
    <>
      <div className={styles['helpdesk']} data-testid="helpdesk-test-id">
        {helpingData?.map((data, index) => (
          <Fragment key={data.title}>
            <div className={styles['helpdesk-container']} data-testid="helpdesk-container-test-id">
              <HelpDeskImg {...data} />
              <h3 className={styles['title']}>{data.title}</h3>
              <span className={styles['description']}>{data.description}</span>
              <div className={styles['button-container']}>
                <GenericLink href={data.button.url} target={data.button.target}>
                  <span className={styles['button-label']}>{data.button.text}</span>
                  <span className={styles['icon']}>
                    <FAIcon iconName={'chevron-right'} />
                  </span>
                </GenericLink>
              </div>
            </div>
            {isMobile || helpingData.length - 1 !== index ? <div className={styles['division']}></div> : ''}
          </Fragment>
        ))}
      </div>
      <div className={styles['footer']} data-testid="footer-test-id">
        {renderFooter()}
      </div>
    </>
  );
};

export default FooterNavigation;
